/**
 * sampleComplaints.js — Conteúdo de demonstração (Group H / req 2.13)
 *
 * Cartões de exemplo realistas, porém TOTALMENTE FICTÍCIOS (sem nomes reais,
 * sem PII), usados apenas no contexto de prospecção/demonstração de vendas.
 *
 * IMPORTANTE: Estes dados NUNCA devem ser misturados a dados reais de clientes
 * nem contabilizados em métricas reais. Renderize-os somente quando o contexto
 * de demonstração estiver ativo (prop/flag `demo`) e o quadro real estiver vazio.
 *
 * Formato alinhado ao shape consumido pelo InvestigationDashboard (Kanban):
 *  - id / protocol_number  -> "#01..", numeração por cliente
 *  - status                -> received | investigating | resolved | closed
 *  - priority              -> critical | high | medium | low
 *  - completion_percentage -> 0..100
 *  - created_at            -> data ISO válida (nunca epoch)
 *  - description           -> relato curto anonimizado
 *  - tags                  -> rótulos de categorização
 *  - responses             -> tipo_denuncia / descricao_fatos / empresa_slug
 *  - status_conclusao / conclusao -> desfecho (apenas resolvidas/arquivadas)
 */

export const SAMPLE_DEMO_CLIENT_SLUG = 'empresa-demo';

const sampleComplaints = [
  {
    id: 'demo-1',
    protocol_number: '01',
    status: 'received',
    priority: 'high',
    completion_percentage: 10,
    created_at: '2024-02-05T09:15:00.000Z',
    description:
      'Relato de tratamento hostil e humilhações recorrentes por parte de uma liderança durante reuniões de equipe.',
    tags: ['Assédio Moral', 'Liderança'],
    responses: {
      tipo_denuncia: 'Assédio Moral',
      descricao_fatos:
        'Colaborador relata cobranças agressivas e exposição da equipe em reuniões, gerando ambiente intimidador.',
      empresa_slug: SAMPLE_DEMO_CLIENT_SLUG,
      identificacao: 'Não',
      sobre_quem: 'diretores'
    }
  },
  {
    id: 'demo-2',
    protocol_number: '02',
    status: 'investigating',
    priority: 'critical',
    completion_percentage: 55,
    created_at: '2024-02-12T14:40:00.000Z',
    description:
      'Suspeita de irregularidade em processo de compras com possível favorecimento de fornecedor.',
    tags: ['Fraude', 'Compras', 'Conflito de Interesses'],
    responses: {
      tipo_denuncia: 'Fraude / Corrupção',
      descricao_fatos:
        'Indícios de direcionamento de contrato a fornecedor específico sem cotação adequada.',
      empresa_slug: SAMPLE_DEMO_CLIENT_SLUG,
      identificacao: 'Sim',
      sobre_quem: 'demais_colaboradores'
    }
  },
  {
    id: 'demo-3',
    protocol_number: '03',
    status: 'investigating',
    priority: 'medium',
    completion_percentage: 40,
    created_at: '2024-02-18T11:05:00.000Z',
    description:
      'Comunicação de desrespeito e linguagem inadequada entre colegas de um mesmo setor.',
    tags: ['Desrespeito', 'Clima Organizacional'],
    responses: {
      tipo_denuncia: 'Desrespeito',
      descricao_fatos:
        'Relato de comentários ofensivos e tom desrespeitoso em interações cotidianas no setor.',
      empresa_slug: SAMPLE_DEMO_CLIENT_SLUG,
      identificacao: 'Não',
      sobre_quem: 'demais_colaboradores'
    }
  },
  {
    id: 'demo-4',
    protocol_number: '04',
    status: 'resolved',
    priority: 'high',
    completion_percentage: 100,
    created_at: '2024-01-20T08:30:00.000Z',
    description:
      'Denúncia de descumprimento de norma de segurança do trabalho em área operacional.',
    tags: ['Segurança do Trabalho', 'Compliance'],
    status_conclusao: 'procedente',
    conclusao:
      'Apuração confirmou a falha de procedimento. Medidas corretivas e treinamento foram aplicados.',
    responses: {
      tipo_denuncia: 'Segurança do Trabalho',
      descricao_fatos:
        'Equipe operando sem equipamento de proteção exigido em determinada atividade.',
      empresa_slug: SAMPLE_DEMO_CLIENT_SLUG,
      identificacao: 'Sim',
      sobre_quem: 'demais_colaboradores'
    }
  },
  {
    id: 'demo-5',
    protocol_number: '05',
    status: 'closed',
    priority: 'low',
    completion_percentage: 100,
    created_at: '2024-01-08T16:10:00.000Z',
    description:
      'Relato sobre uso indevido de recursos da empresa para fins pessoais.',
    tags: ['Uso de Recursos', 'Conduta'],
    status_conclusao: 'improcedente',
    conclusao:
      'Após apuração, não foram encontradas evidências que sustentassem a denúncia. Caso arquivado.',
    responses: {
      tipo_denuncia: 'Uso Indevido de Recursos',
      descricao_fatos:
        'Suspeita de utilização de equipamentos corporativos fora do contexto de trabalho.',
      empresa_slug: SAMPLE_DEMO_CLIENT_SLUG,
      identificacao: 'Não',
      sobre_quem: 'demais_colaboradores'
    }
  }
];

/** Retorna os cartões de exemplo de um determinado status do workflow. */
export const getSampleComplaintsByStatus = (status) =>
  sampleComplaints.filter((complaint) => complaint.status === status);

export default sampleComplaints;
